const TRUNCATE_CHIP_LENGTH = 13;

export const truncateText = (text: string) => {
    return `${text.slice(0, TRUNCATE_CHIP_LENGTH)}…${text.slice(
        text.length - TRUNCATE_CHIP_LENGTH,
        text.length
    )}`;
};
